import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  children: string;
};

export const Body = styled.div<Props>(
  ({theme}) => css`
    ${theme.typography.labelSmallBold};
    padding: 8px;
    border-radius: 4px;
    color: var(--color);
    background: var(--background);
    white-space: nowrap;
    ${theme.elevations.large};
  `
);
